module.exports = __webpack_public_path__ + "img/sup-speed.154ac7cb.png";